import styled from 'styled-components'

import { Section as SectionDS } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { colors, media, radii, space } = theme

export const Section = styled(SectionDS)`
  padding-top: ${space['spacing-xxl']};

  h1 {
    margin-bottom: ${space['spacing-md']};
  }

  & > div > div:nth-child(2) {
    position: absolute;
    top: 0;
    right: 0;
    width: 40vw;
  }

  .ds-button {
    border-radius: ${radii['corner-radius-pill']};
    justify-content: center;
  }
`

export const Highlight = styled.span`
  color: ${colors['cashme-magenta']};
  font: inherit;
`

export const LoanInfos = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['spacing-xs']};
  margin-bottom: ${space['spacing-md']};

  @media (${media.tablet}) {
    gap: ${space['spacing-sm']};
    margin-bottom: ${space['spacing-xl']};
  }

  @media (${media.desktop}) {
    gap: ${space['spacing-md']};
  }
`

export const LoanInfosItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${space['spacing-sm']};

  > svg {
    margin-bottom: ${space['spacing-xxs']};

    @media (${media.tablet}) {
      margin-bottom: 0;
    }
  }
`

export const ImageWrapper = styled.div`
  display: block;
  position: relative;
  width: 100%;
  height: 100%;

  img {
    border-bottom-left-radius: 10rem;
    max-height: 650px;
    object-fit: cover;
    object-position: top;
  }

  & > svg {
    position: absolute;
    left: 0;
    transform: translate(-50%, 100%);
  }

  @media (max-width: 1240px) {
    img {
      max-height: 450px;
    }
  }
`
